/* TODO: this should be replaced by a user context */
export const getSessionData = () => {
  if (typeof window !== 'undefined') {
    return window?.localStorage.getItem('sessionData');
  }
  return null;
};
